import { mozartAdapter } from './mozart.adapter';
import { dpReduxAction } from 'shared/infra/redux';
import { mozartRepository } from './mozart.repository';
import { unseenAlerts } from 'features/mozart-notifications/domain';
import partnerActions from 'redux/actions/partners-actions/partners.actions';
import { subscribeEvent, publishEvent, unsubscribeEvent } from 'shared/libs';

import type {
  SetNotificationSeenByIdParams,
  SetTurnOffProductParams,
  UnseenAlerts,
} from 'features/mozart-notifications/domain';

export function getNumberOfUnseenAlerts(): UnseenAlerts {
  const value = mozartRepository.readUnseenAlerts();
  return unseenAlerts.create(value);
}

export function getPartnerId() {
  return mozartRepository.readPartnerIdFromProfile();
}

export function getListOfStores() {
  return mozartRepository.readStoresFromProfile();
}

export async function getAllNotifications() {
  const _notis = await mozartRepository.readAllNotifications();
  const stores = mozartRepository.readStoresFromProfile({ asHook: false });
  return mozartAdapter.toMozartNotification({ stores, list: _notis.data });
}

export async function setNotificationSeenById(
  params: SetNotificationSeenByIdParams,
) {
  const { id, createdAt } = params;
  const payload = mozartAdapter.toNotificationSeenById({ createdAt });
  return await mozartRepository.updateNotificationSeenById({ id, payload });
}

export async function setTurnOffProduct(params: SetTurnOffProductParams) {
  const payload = mozartAdapter.toTurnOffProductByStoreId(params);
  const response = await mozartRepository.updateTurnOffProduct({ payload });
  return response.status === 200;
}

export function mozartDialogOpened() {
  const EVENT_NAME = 'MOZART_DIALOG_OPENED';
  type Detail = boolean;
  type EventData = CustomEvent<Detail>;
  type ListenerFN = (e: EventData) => void;
  let theListener: ListenerFN = () => undefined;
  return {
    dispatch: (d: Detail) => publishEvent(EVENT_NAME, d),
    remove: () => unsubscribeEvent(EVENT_NAME, theListener),
    add: (lt: ListenerFN) => {
      theListener = lt;
      subscribeEvent(EVENT_NAME, theListener);
    },
  };
}

export function reloadStateNotificationsNew() {
  dpReduxAction(partnerActions.getState());
}

export const mozartService = {
  getNumberOfUnseenAlerts,
  getPartnerId,
  getListOfStores,
  getAllNotifications,
  setNotificationSeenById,
  setTurnOffProduct,
  mozartDialogOpened,
  reloadStateNotificationsNew,
};
